import script from "./AttachmentsInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsInput.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentsInput.vue?vue&type=style&index=0&id=6fb97027&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb97027"]])

export default __exports__